import {
  TrackmanParameterCategoryDto,
  TrackmanParameterSubcategoryDto,
  TrackmanParameterSubcategoryRequest,
} from 'types/admin/trackmanParameterCategories';

export const moveArrayItemById = <T extends { id: string }>(items: T[], id: string, direction: 'up' | 'down'): T[] => {
  const fromIndex = items.findIndex((item) => item.id === id);
  if (fromIndex === -1) return items;

  const toIndex = direction === 'up' ? fromIndex - 1 : fromIndex + 1;
  if (toIndex < 0 || toIndex >= items.length) return items;

  const nextItems = [...items];
  [nextItems[fromIndex], nextItems[toIndex]] = [nextItems[toIndex], nextItems[fromIndex]];
  return nextItems;
};

export const getCategoryUsageCount = (category: TrackmanParameterCategoryDto): number =>
  category.subcategories.reduce((total, subcategory) => total + subcategory.usageCount, 0);

export const isDuplicateSubcategoryTitle = (
  category: TrackmanParameterCategoryDto,
  title: string,
  ignoreSubcategoryId?: string
): boolean =>
  category.subcategories.some(
    (subcategory) => subcategory.id !== ignoreSubcategoryId && subcategory.title.trim().toLowerCase() === title.trim().toLowerCase()
  );

export const toSubcategoryRequests = (subcategories: TrackmanParameterSubcategoryDto[]): TrackmanParameterSubcategoryRequest[] =>
  subcategories.map(({ id, title }) => ({ id, title }));
